import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { CAUSAS_NOTIFICACION } from './../../../constants/constants';

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

//SERVICIOS
import { DocumentoService } from 'src/app/services/documento.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { GestorService} from 'src/app/services/gestor.service';
import { TransportistaService} from 'src/app/services/transportista.service';
import { CentroService } from 'src/app/services/centro.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { EmailService } from 'src/app/services/email.service';
import { MatOption } from '@angular/material/core';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-validacion',
  templateUrl: './validacion.component.html',
  styleUrls: ['./validacion.component.scss']
})
export class ValidacionComponent implements OnInit {

  public documento: any;
  public newComentario: any;
  public comentarios?: any[];
  public causasNotificacion: String[];
  public notificaciones: any= {};
  public path: any;
  public tipo: any
  public idPadre: any
  public tipoPadre: any
  public idAnterior: any
  public url: any
  data: any
  
   public comentariosSeguridadSocial: any[] = []
   public hacienda: any
   public seguridadSocial: any
   public contratista: any
   public comentario: any
   public comentariosHacienda: any[] = []
   public clase:any
   public clase1:any
   public comentariosGestor1:any
   public comentariosGestor2:any
   public comentariosGestor3:any
   public comentariosGestor4:any
   public comentariosGestor5:any
   public gestor: any
   public comentarios1: any
   public tipoAut: any
   public comentariosTransportista1:any
   public comentariosTransportista2:any
   public comentariosTransportista3:any
   public comentariosTransportista4:any
   public comentariosTransportista5:any
   public comentariosCentro1:any
   public comentariosCentro2:any
   public comentariosCentro3:any
   public comentariosCentro4:any
   public transportista: any
   public centro: any
   public comentarios2: any
   public comentarios3: any
   idUserDoc:any
   dataDoc: any
   observaciones:any =[]
   userLog:any

  constructor(@Inject(MAT_DIALOG_DATA) public info: {
    id: string,
    refresh: any
  }, private formBuilder: FormBuilder, private apollo: Apollo, 
  private documentoServicio: DocumentoService, private router: Router, private contratistaService: ContratistaService,
  private gestorService: GestorService, private transportistaService: TransportistaService, 
  private centroService: CentroService, private usuarioService: UsuariosService, private emailService:EmailService) {
    this.causasNotificacion = CAUSAS_NOTIFICACION
    this.path = this.router.url
  
  }

  ngOnInit(): void {
    this.getDocumentoById()
    this.buildForm()
   /*  console.log(this.path) */
  }

  private buildForm(){
    this.notificaciones = this.formBuilder.group({
      causa: ['', [Validators.required]],
      comentario: ['',[Validators.required]],
    });
  }

  getDocumentoById(){
    this.apollo.watchQuery<any>({
      query: this.documentoServicio.getDocumentoById(),
      variables: {
        "id": this.info.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
     console.log(data)
        this.documento = data.documento
        this.url = this.documento?.url

        this.comentarios = Object.assign([], this.documento?.comentarios)
     
        this.contratista= this.documento?.contratista
        this.comentariosSeguridadSocial = Object.assign([], this.contratista?.comentariosSeguridadSocial);
        this.comentariosHacienda = Object.assign([], this.contratista?.comentariosHacienda);
        this.gestor= this.documento?.gestor
        this.transportista= this.documento?.transportista
        this.centro = this.documento?.centro;
    
        this.tipoAut = this.documento?.nombreArchivo
        this.idUserDoc = this.documento.subidoPor;
        console.log(this.idUserDoc)
         switch (this.tipoAut) {
          case 'autorizacion1':
            this.comentarios1 = Object.assign([], this.gestor?.comentariosAutorizacion1);
            this.comentarios2 = Object.assign([], this.transportista?.comentariosAutorizacion1);
            break;
          case 'autorizacion2':
            this.comentarios1 = Object.assign([], this.gestor?.comentariosAutorizacion2);
            this.comentarios2 = Object.assign([], this.transportista?.comentariosAutorizacion2);
            break;
          case 'autorizacion3':
            this.comentarios1 = Object.assign([], this.gestor?.comentariosAutorizacion3);
             this.comentarios2 = Object.assign([], this.transportista?.comentariosAutorizacion3);
            break;
          case 'autorizacion4':
            this.comentarios1 = Object.assign([], this.gestor?.comentariosAutorizacion4);
            this.comentarios2 = Object.assign([], this.transportista?.comentariosAutorizacion4);
            break;
          case 'autorizacion5':
            this.comentarios1 = Object.assign([], this.gestor?.comentariosAutorizacion5);
            this.comentarios2 = Object.assign([], this.transportista?.comentariosAutorizacion5);
            break;

          case 'residuosPeligrosos':
            this.comentarios3 = Object.assign([], this.centro?.comentariosResPeligrosos)
            break;

          case 'residuosNoPeligrosos':
            this.comentarios3 = Object.assign([], this.centro?.comentariosResNoPeligrosos)
            break;

          case 'informeResiduos':
            this.comentarios3 = Object.assign([], this.centro?.comentariosJustResiduos)
            break;

          case 'contratoTratamiento1':
            this.comentarios3 = Object.assign([], this.centro?.comentariosContrato1)
            break;

          case 'contratoTratamiento2':
              this.comentarios3 = Object.assign([], this.centro?.comentariosContrato2)
            break;

          case 'contratoTratamiento3':
              this.comentarios3 = Object.assign([], this.centro?.comentariosContrato3)
            break;
          default:

            break;
        } 
        
      })
  }
  //comentarios para documentos que no sean Seguridad social y hacienda
   addComentario(){
    this.newComentario = this.notificaciones.value
    this.newComentario.fecha = new Date()
    this.comentarios?.push(this.newComentario)
  } 
  updateComentarios() {
    if (this.contratista) {
      this.updateContratistaComentarios()
    } 
    if (this.gestor) {
      this.updateGestorComentarios()
    } 
    if (this.transportista) {
      this.updateTransportistaComentarios()
    }
    if(this.centro){
      this.updateCentroComentarios()
    }
  }


  setEmptyInputs(){
    this.notificaciones.reset()
  }

   //comentarios para documentos de Seguridad social y hacienda
  updateContratistaComentarios(){
    if (this.documento.seguridadSocial) {
      console.log(this.notificaciones.value)
      this.newComentario = this.notificaciones.value
      this.newComentario.fecha = new Date()
      this.comentariosSeguridadSocial?.push(this.newComentario)
      console.log(this.comentariosSeguridadSocial)
    } 
     
    if (this.documento.hacienda) {
      this.newComentario = this.notificaciones.value
      this.newComentario.fecha = new Date()
      this.comentariosHacienda?.push(this.newComentario)
    }
    
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.documento.contratista.id
          },
          "data": {
            "comentariosSeguridadSocial": this.comentariosSeguridadSocial,
            "comentariosHacienda": this.comentariosHacienda,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

//comentarios para documentos de autorizaciones del Gestor
 updateGestorComentarios(){
   this.tipoAut = this.documento.nombreArchivo
   this.comentariosGestor1 = Object.assign([], this.documento.gestor?.comentariosAutorizacion1)
   this.comentariosGestor2 = Object.assign([], this.documento.gestor?.comentariosAutorizacion2)
   this.comentariosGestor3 = Object.assign([], this.documento.gestor?.comentariosAutorizacion3)
   this.comentariosGestor4 = Object.assign([], this.documento.gestor?.comentariosAutorizacion4)
   this.comentariosGestor5 = Object.assign([], this.documento.gestor?.comentariosAutorizacion5)
    switch (this.tipoAut) {
          case 'autorizacion1':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosGestor1?.push(this.newComentario)
            break;
          case 'autorizacion2':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosGestor2?.push(this.newComentario);
            /* console.log(this.comentariosGestor2) */
            break;
             case 'autorizacion3':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosGestor3?.push(this.newComentario);
           /*  console.log(this.comentariosGestor3) */
            break;  
             case 'autorizacion4':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosGestor4?.push(this.newComentario);
            /* console.log(this.comentariosGestor4) */
            break;  
             case 'autorizacion5':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosGestor5?.push(this.newComentario);
            /* console.log(this.comentariosGestor5) */
            break;       
          default:
            break;
        }
    this.apollo.mutate({
      mutation: this.gestorService.updateGestor(),
      variables: {
        "input": {
          "where": {
            "id": this.documento.gestor.id
          },
          "data": {
            "comentariosAutorizacion1": this.comentariosGestor1,
            "comentariosAutorizacion2": this.comentariosGestor2,
            "comentariosAutorizacion3": this.comentariosGestor3,
            "comentariosAutorizacion4": this.comentariosGestor4,
            "comentariosAutorizacion5": this.comentariosGestor5,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO GESTOOOOR", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  //comentarios para documentos de autorizaciones del Gestor
 updateTransportistaComentarios(){
   this.tipoAut = this.documento.nombreArchivo
   this.comentariosTransportista1 = Object.assign([], this.documento.transportista?.comentariosAutorizacion1)
   this.comentariosTransportista2 = Object.assign([], this.documento.transportista?.comentariosAutorizacion2)
   this.comentariosTransportista3 = Object.assign([], this.documento.transportista?.comentariosAutorizacion3)
   this.comentariosTransportista4 = Object.assign([], this.documento.transportista?.comentariosAutorizacion4)
   this.comentariosTransportista5 = Object.assign([], this.documento.transportista?.comentariosAutorizacion5)
    switch (this.tipoAut) {
          case 'autorizacion1':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosTransportista1?.push(this.newComentario)
            break;
          case 'autorizacion2':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosTransportista2?.push(this.newComentario);
            /* console.log(this.comentariosGestor2) */
            break;
             case 'autorizacion3':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosTransportista3?.push(this.newComentario);
           /*  console.log(this.comentariosGestor3) */
            break;  
             case 'autorizacion4':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosTransportista4?.push(this.newComentario);
            /* console.log(this.comentariosGestor4) */
            break;  
             case 'autorizacion5':
            this.newComentario = this.notificaciones.value
            this.newComentario.fecha = new Date()
            this.comentariosTransportista5?.push(this.newComentario);
            /* console.log(this.comentariosGestor5) */
            break;       
          default:
            break;
        }
    this.apollo.mutate({
      mutation: this.transportistaService.updateTransportista(),
      variables: {
        "input": {
          "where": {
            "id": this.documento.transportista.id
          },
          "data": {
            "comentariosAutorizacion1": this.comentariosTransportista1,
            "comentariosAutorizacion2": this.comentariosTransportista2,
            "comentariosAutorizacion3": this.comentariosTransportista3,
            "comentariosAutorizacion4": this.comentariosTransportista4,
            "comentariosAutorizacion5": this.comentariosTransportista5,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO TRANSPORTISTA", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  updateCentroComentarios(){
    this.tipoAut = this.documento.nombreArchivo
    this.comentariosCentro1 = Object.assign([], this.documento.centro?.comentariosResPeligrosos)
    this.comentariosCentro2 = Object.assign([], this.documento.transportista?.comentariosResNoPeligrosos)
    this.comentariosCentro3 = Object.assign([], this.documento.transportista?.comentariosCertMemoria)
    this.comentariosCentro4 = Object.assign([], this.documento.transportista?.comentariosJustResiduos)
    
     switch (this.tipoAut) {
           case 'residuosPeligrosos':
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro1?.push(this.newComentario)
             break;
           case 'residuosNoPeligrosos':
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro2?.push(this.newComentario);
          
             break;
              case 'informeResiduos':
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro3?.push(this.newComentario);
         
             break;  
              case 'contratoTratamiento1':
             this.newComentario = this.notificaciones.value
             this.newComentario.fecha = new Date()
             this.comentariosCentro4?.push(this.newComentario);
    
             break;  
                    
           default:
             break;
         }
     this.apollo.mutate({
       mutation: this.centroService.updateCentro(),
       variables: {
         "input": {
           "where": {
             "id": this.documento.centro.id
           },
           "data": {
             "comentariosResPeligrosos": this.comentariosCentro1,
             "comentariosResNoPeligrosos": this.comentariosCentro2,
             "comentariosCertMemoria": this.comentariosCentro3,
             "comentariosJustResiduos": this.comentariosCentro4,
            
           }
         }    
       }
     })
       .subscribe(({data, errors}) => {
         console.log("EDITADO CENTRO", data, errors)
       }, (error) => {
         console.log('aaaaa',error)
       })
   }


  //documento validado
  updateValidacionDocumentoById(){
   
    if (this.documento.tipo === "seguridadSocialPendiente") {
      this.tipo= "seguridadSocialActivo"
    } else if (this.documento.tipo === "haciendaPendiente") {
      this.tipo= "haciendaActivo"
    } else if (this.documento.tipo === "pendiente") {
      this.tipo= "activo"
    } 
    if (this.documento.fechaCaducidad <= this.documentoServicio.getActualDate()) {
      this.apollo.mutate({
        mutation: this.documentoServicio.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"rojo",
              "fechaCheck": this.documentoServicio.getActualDate()
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumento.documento.idPadre
          this.tipoPadre = this.data.updateDocumento.documento.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1000);
        }, (error) => {
          console.log('aaaaa',error)
        })
    }
    if (this.documento.fechaCaducidad > this.documentoServicio.getNextMonth() && this.documento.fechaCaducidad > this.documentoServicio.getActualDate()) {
      this.apollo.mutate({
        mutation: this.documentoServicio.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"verde",
              "fechaCheck": this.documentoServicio.getActualDate()
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumento.documento.idPadre
          this.tipoPadre = this.data.updateDocumento.documento.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1000);
        }, (error) => {
          console.log('aaaaa',error)
        })
    } 

    if (this.documento.noCaduca == true) {
      this.apollo.mutate({
        mutation: this.documentoServicio.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"verde",
              "fechaCheck": this.documentoServicio.getActualDate()
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumento.documento.idPadre
          this.tipoPadre = this.data.updateDocumento.documento.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1000);
        }, (error) => {
          console.log('aaaaa',error)
        })
    } 

    if (this.documento?.fechaCaducidad <= this.documentoServicio.getNextMonth() && this.documento?.fechaCaducidad > this.documentoServicio.getActualDate()) {
      this.apollo.mutate({
        mutation: this.documentoServicio.updateDocumentoById(),
        variables: {
          "input": {
            "where": {
              "id": this.documento.id
            },
            "data": {
              "validado": true,
              "tipo": this.tipo,
              "estado":"amarillo",
              "fechaCheck": this.documentoServicio.getActualDate()
            }
          }    
        }
      })
        .subscribe(({data, errors}) => {
          console.log("EDITADO", data)
          this.data= data
          this.idPadre = this.data.updateDocumento.documento.idPadre
          this.tipoPadre = this.data.updateDocumento.documento.tipo
          if (this.idPadre != null){
            this.updateDocumentoAnteriorById()
          } 
          setTimeout(() => {
            location.reload()
           }, 1000);
        }, (error) => {
          console.log('aaaaa',error)
        })
    }
    
  }
  
  
  //Para cambiar estado del documento anterior que va a reemplazar
  updateDocumentoAnteriorById(){
    console.log(this.tipoPadre)
    if (this.tipoPadre === "seguridadSocialPendiente" || this.tipoPadre === "seguridadSocialActivo") {
      this.tipo= "seguridadSocialInactivo"
    } else if (this.tipoPadre === "haciendaPendiente" || this.tipoPadre === "haciendaActivo") {
      this.tipo= "haciendaInactivo"
    } else if (this.tipoPadre === "pendiente" || this.tipoPadre === "activo") {
      this.tipo= "inactivo"
    }
    this.apollo.mutate({
      mutation: this.documentoServicio.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.idPadre
          },
          "data": {
            "validado": true,
            "tipo": this.tipo,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
        setTimeout(() => {
            location.reload()
           }, 1000);
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  //Documento no valido
  updateDocumentoNoValidadoById(){
    console.log(this.documento)
     if (this.documento.tipo === "seguridadSocialPendiente") {
      this.tipo= "seguridadSocialNoValido"
    } else if (this.documento.tipo === "haciendaPendiente") {
      this.tipo= "haciendaNoValido"
    } else if (this.documento.tipo === "pendiente") {
      this.tipo= "noValido"
    } 
    this.apollo.mutate({
      mutation: this.documentoServicio.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.documento.id
          },
          "data": {
            "validado": false,
            "tipo":this.tipo
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
        this.data= data
        this.idAnterior = this.data.updateDocumento.documento.id
        this.idPadre = this.data.updateDocumento.documento.idPadre
        this.tipoPadre = this.data.updateDocumento.documento.tipo
        if (this.idPadre != null){
          this.updateDocumentoAnteriorNoValidadoById()
        } 
        if (this.tipoPadre === "seguridadSocialNoValido" || this.tipoPadre === "haciendaNoValido" || this.tipoPadre === "noValido") {
           this.getUsuarioById(this.idUserDoc)
           setTimeout(() => {
            this.deleteDocumentoById(this.idAnterior)
           }, 3500);
           
        }
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  getUsuarioById(id:any){
    this.apollo.watchQuery<any>({
      query: this.usuarioService.getUsuariosById(),
      variables: {
        id,
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        const mail = data.user.email
        const userName = data.user.username
       

        this.getDocumentoByIdDocRech(this.idAnterior)
        setTimeout(() => {
         
           if (this.dataDoc.contratista != null) {
            this.getContratistaById(this.dataDoc.contratista.id);
            return
           }

           if (this.dataDoc.centro != null) {
            this.getCentroById(this.dataDoc.centro.id);
            return
          }

          if (this.dataDoc.gestor != null) {
            this.getGestorById(this.dataDoc.gestor.id)
            return
          }

          if (this.dataDoc.transportista != null) {
            this.getTransportistaById(this.dataDoc.transportista.id);
            return
          }
              
          
        }, 2000);
        setTimeout(() => {
          console.log(this.observaciones)
          this.sendMail(userName, this.dataDoc.nombre, this.observaciones, mail, id)
        }, 3000);
        
        
      })
  }

  async sendMail(userName:any, nArchivo:any, observacion:any, mail:any, idUser:any){
    const templateDocRech = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/Problema_Documental_Xtensa_72a70b3570.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        
        <p>Estimado ${userName}</p>
        <p>Lamentamos comunicarle que la documentación que ha proporcionado por medio de la herramienta ha sido rechazada en el proceso de verificación.</p>
        <h5>Nombre del archivo</h5>
        <p>${nArchivo}</p>
        <h5>Observaciones:</h5>
        <p>${observacion}</p>
        </div>
        </body>

        </html>`;


           await this.emailService.send(
              mail,
              'Documento Rechazado',
              templateDocRech
            );
     this.updateUser('Lamentamos comunicarle que la documentación que ha proporcionado por medio de la herramienta ha sido rechazada en el proceso de verificación, se ha enviado un email a su bandeja de entrada con más información.', idUser)

  }
  updateUser(mensaje:any, id:any){
    this.apollo.mutate({
    mutation: this.usuarioService.updateUsuario(),
    variables: {
      "input": {
        "where": {
          "id": id
        },
        "data": {
          "mensaje": mensaje
        }
      }    
    }
  })
    .subscribe(({data, errors}) => {
     console.log(data);
     
    }, (error) => {
      /* console.log('aaaaa',error) */
    })
}

  //Para cambiar estado del documento anterior con la notificación de no aceptado
  updateDocumentoAnteriorNoValidadoById(){
    console.log(this.tipoPadre)
    if (this.tipoPadre === "seguridadSocialNoValido") {
      this.tipo= "seguridadSocialActivoEnEspera"
    } else if (this.tipoPadre === "haciendaNoValido") {
      this.tipo= "haciendaActivoEnEspera"
    } else if (this.tipoPadre === "noValido") {
      this.tipo= "enEspera"
    }
    this.apollo.mutate({
      mutation: this.documentoServicio.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.idPadre
          },
          "data": {
            "tipo": this.tipo,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO NUEVOOOO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }
  //eliminar el registro que no es validado
   deleteDocumentoById(id: String){
    this.apollo.mutate({
      mutation: this.documentoServicio.deleteDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', data)
      }, (error) => {
        console.log(error)
      })
  }

  updateComentarioDocumentoById(){
    this.addComentario()
    console.log(this.newComentario)
    console.log(this.comentarios)
    this.apollo.mutate({
      mutation: this.documentoServicio.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.info.id
          },
          "data": {
            "comentarios": this.comentarios,
            /* "comentariosNuevos": true, */
            "solicitudReemplazo": true
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
        this.setEmptyInputs()
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  getDocumentoByIdDocRech(id:any){
    this.apollo.watchQuery<any>({
      query: this.documentoServicio.getDocumentoById(),
      variables: {
        "id": id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        this.dataDoc = data.documento
      
        
      })
  }

  getContratistaById(id:any){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {

        switch (this.dataDoc.nombreArchivo) {
          case 'hacienda':
            if (data.contratista.comentariosHacienda.length == 0) {
              this.observaciones = data.contratista.comentariosHacienda[0].comentario
            }else{
              this.observaciones = data.contratista.comentariosHacienda[data.contratista.comentariosHacienda.length-1].comentario
            }
            
            break;
          case 'seguridadSocial':
            if (data.contratista.comentariosSeguridadSocial.length == 0) {
              console.log(data.contratista.comentariosSeguridadSocial)
              this.observaciones = data.contratista.comentariosSeguridadSocial[0].comentario
            }else{
              this.observaciones = data.contratista.comentariosSeguridadSocial[data.contratista.comentariosSeguridadSocial.length-1].comentario
            }
           
            break;
          default:
            break;
        }
      })
  }

  getCentroById(id:any){  
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentroById(),
      variables: {
        id: id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        switch (this.dataDoc.nombreArchivo) {
          case 'residuosPeligrosos':
            if (data.centro.comentariosResPeligrosos.length == 0) {
              this.observaciones = data.centro.comentariosResPeligrosos[0].comentario
            }else{
              this.observaciones = data.centro.comentariosResPeligrosos[data.centro.comentariosResPeligrosos.length-1].comentario
            }
            
            break;
          case 'residuosNoPeligrosos':
            if (data.centro.comentariosResNoPeligrosos.length == 0) {
              this.observaciones = data.centro.comentariosResNoPeligrosos[0].comentario
            }else{
              this.observaciones = data.centro.comentariosResNoPeligrosos[data.centro.comentariosResNoPeligrosos.length-1].comentario
            }
            
            break;
          case 'informeResiduos':
            if (data.centro.comentariosJustResiduos.length == 0) {
              this.observaciones = data.centro.comentariosJustResiduos[0].comentario
            }else{
              this.observaciones = data.centro.comentariosJustResiduos[data.centro.comentariosJustResiduos.length-1].comentario
            }
              
              break;
          case 'contratoTratamiento1':
            if (data.centro.comentariosContrato1.length == 0) {
              this.observaciones = data.centro.comentariosContrato1[0].comentario
            }else{
              this.observaciones = data.centro.comentariosContrato1[data.centro.comentariosContrato1.length-1].comentario
            }
            break;
          case 'contratoTratamiento2':
            if (data.centro.comentariosContrato2.length == 0) {
              this.observaciones = data.centro.comentariosContrato2[0].comentario
            }else{
              this.observaciones = data.centro.comentariosContrato2[data.centro.comentariosContrato2.length-1].comentario
            }
            
            break;
          case 'contratoTratamiento3':
            if (data.centro.comentariosContrato3.length == 0) {
              this.observaciones = data.centro.comentariosContrato3[0].comentario
            }else{
              this.observaciones = data.centro.comentariosContrato3[data.centro.comentariosContrato3.length-1].comentario
            }
            
            break;  
          default:
            break;
        }
      })
  }

  getGestorById(id:any){  

    this.apollo.watchQuery<any>({
      query: this.gestorService.getGestorById(),
      variables: {
        id: id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        switch (this.dataDoc.nombreArchivo) {
          case 'autorizacion1':
            if (data.gestor.comentariosAutorizacion1.length == 0) {
              this.observaciones = data.gestor.comentariosAutorizacion1[0].comentario
            }else{
              this.observaciones = data.gestor.comentariosAutorizacion1[data.gestor.comentariosAutorizacion1.length-1].comentario
            }
            
            break;
          case 'autorizacion2':
            if (data.gestor.comentariosAutorizacion2.length == 0) {
              this.observaciones = data.gestor.comentariosAutorizacion2[0].comentario
            }else{
              this.observaciones = data.gestor.comentariosAutorizacion2[data.gestor.comentariosAutorizacion2.length-1].comentario
            }
            
            break;
          case 'autorizacion3':
            if (data.gestor.comentariosAutorizacion3.length == 0) {
              this.observaciones = data.gestor.comentariosAutorizacion3[0].comentario
            }else{
              this.observaciones = data.gestor.comentariosAutorizacion3[data.gestor.comentariosAutorizacion3.length-1].comentario
            }
              
              break;
          case 'autorizacion4':
            if (data.gestor.comentariosAutorizacion4.length == 0) {
              this.observaciones = data.gestor.comentariosAutorizacion4[0].comentario
            }else{
              this.observaciones = data.gestor.comentariosAutorizacion4[data.gestor.comentariosAutorizacion4.length-1].comentario
            }
            
            break;
          case 'autorizacion5':
            if (data.gestor.comentariosAutorizacion5.length == 0) {
              this.observaciones = data.gestor.comentariosAutorizacion5[0].comentario
            }else{
              this.observaciones = data.gestor.comentariosAutorizacion5[data.gestor.comentariosAutorizacion5.length-1].comentario
            }
            
            break; 
          default:
            break;
        }
      })
  }

  getTransportistaById(id:any) {

    this.apollo.watchQuery<any>({
      query: this.transportistaService.getTransportistaById(),
      variables: {
        id: id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        switch (this.dataDoc.nombreArchivo) {
          case 'autorizacion1':
          if (data.transportista.comentariosAutorizacion1.length == 0) {
            this.observaciones =  data.transportista.comentariosAutorizacion1[0].comentario
          }else{
            this.observaciones =  data.transportista.comentariosAutorizacion1[data.transportista.comentariosAutorizacion1.length-1].comentario
          }
              
            break;
          case 'autorizacion2':
            if (data.transportista.comentariosAutorizacion2.length == 0) {
              this.observaciones = data.transportista.comentariosAutorizacion2[0].comentario
            }else{
              this.observaciones = data.transportista.comentariosAutorizacion2[data.transportista.comentariosAutorizacion2.length-1].comentario
            }
            
            break;
          case 'autorizacion3':
            if (data.transportista.comentariosAutorizacion3.length == 0) {
              this.observaciones = data.transportista.comentariosAutorizacion3[0].comentario
            }else{
              this.observaciones = data.transportista.comentariosAutorizacion3[data.transportista.comentariosAutorizacion3.length-1].comentario
            }
              
              break;
          case 'autorizacion4':
            if (data.transportista.comentariosAutorizacion4.length == 0) {
              this.observaciones = data.transportista.comentariosAutorizacion4[0].comentario
            }else{
              this.observaciones = data.transportista.comentariosAutorizacion4[data.transportista.comentariosAutorizacion4.length-1].comentario
            }
            
            break;
          case 'autorizacion5':
            if (data.transportista.comentariosAutorizacion5.length == 0) {
              this.observaciones = data.transportista.comentariosAutorizacion5[0].comentario
            }else{
              this.observaciones = data.transportista.comentariosAutorizacion5[data.transportista.comentariosAutorizacion5.length-1].comentario
            }
            
            break; 
          default:
            break;
        }
      })
  }

}
